import { PermissionsEnum } from '@/auth/interfaces';
import { UserRoles } from '@/shared/interfaces';

export const USER_ROLES = [
  UserRoles.GERENCIA,
  UserRoles.ADMINISTRADOR,
  UserRoles.SUPERVISOR,
  UserRoles.AGENTE,
];

export const RELATED_PERMISSIONS_SAVEFORM = [
  PermissionsEnum.api_view_empresa,
  PermissionsEnum.api_view_area,
  PermissionsEnum.api_view_departamento,
  PermissionsEnum.auth_view_group,
];
